import React from "react";
import {Collapse, Divider, List, ListItem, ListItemAvatar, ListItemText} from "@material-ui/core";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import ZoomRecordingInstance from "./ZoomRecordingInstance";
import {useDispatch} from "react-redux";
import {zoomIntegrationActionTypes} from "../../_constants/actions/integrations/zoomIntegrationActiontypes";
import {withTranslation} from "react-i18next";

const ZoomRecordingGroupInstance = (props) => {
    const {t, meeting} = props;
    const {uuid} = meeting;

    const handleMeetingToggle = () => {
	    dispatchMeetingToggle();
    	props.handleMeetingAccordion(uuid);
    };

	const dispatch = useDispatch();
	const dispatchMeetingToggle = () => {
		const type = props.isExpanded(uuid)
						? zoomIntegrationActionTypes.ZOOM_MEETING_COLLAPSE
						: zoomIntegrationActionTypes.ZOOM_MEETING_EXPAND;
		dispatch({type: type});
	};

	return(
        <>
            <ListItem button
                      key={"item_" + uuid}
                      onClick={() => handleMeetingToggle(uuid)}
            >
                {/* expand less-more icon/indicator */}
                <ListItemAvatar>{props.isExpanded(uuid) ? <ExpandLess/> : <ExpandMore/>}</ListItemAvatar>

                {/* topic/title */}
                <ListItemText primary={meeting.topic} />
            </ListItem>

            {/* accordion collapse */}
            <Collapse
                key={"collapse_" + uuid}
                component="li"
                in={props.isExpanded(uuid)} // the state is managed in parent
                timeout="auto"
                unmountOnExit
            >
                <List>
                  {/* if no recordings available, show message that recording is being processed */}
                  {meeting.recording_files.length < 1 &&
                  <ListItem>
                    <ListItemText inset={true} secondary={t("Zoom is processing recording...")}/>
                  </ListItem>
                  }

                  {/* if recordings available, show individual recording */}
                  {meeting.recording_files.length >= 1 && meeting.recording_files.map((recording, key) =>
                    <ZoomRecordingInstance
                      key={meeting + "_" + key}
                      recording={recording}
                      handleSelectRecording={props.handleSelectRecording}
                    />
                  )}
                </List>
            </Collapse>

            {/* A recording group divider */}
            <Divider variant="middle" light />
        </>
    )
};

export default withTranslation()(ZoomRecordingGroupInstance)